import FormSelectInput from "./FormSelectInput";

const FormSelectRecipientType = (props) => {
    const loadOptions = async (input) => {
        return [
            { value: 'COMPANY', label: 'All Company' },
            { value: 'LOCATION', label: 'Location' },
            { value: 'INDIVIDUAL', label: 'Specific Users' },
            { value: 'ROLE', label: 'Users By Role' },
        ]
    }

    return (
        <FormSelectInput loadOptions={loadOptions} {...props} />
    )
}

export default FormSelectRecipientType;